import { AedStateEnum, EventQueueView } from '@mark43/cad-api';
import { ModalControls } from './types';

export function aedEventSecondsLeft({
    assignedEventTimeDispatched,
    aedTimeInSeconds,
}: {
    assignedEventTimeDispatched: string;
    aedTimeInSeconds: number;
}) {
    const diffFromNowAndEventInSecs = Math.trunc(
        (new Date().getTime() - new Date(assignedEventTimeDispatched).getTime()) / 1000
    );
    return aedTimeInSeconds - diffFromNowAndEventInSecs;
}

export function closeModalWhenAedIsDone({
    assignedEvent,
    modalControls,
}: {
    assignedEvent: EventQueueView;
    modalControls: ModalControls;
}) {
    if (
        assignedEvent?.aedState === AedStateEnum.SUCCESS.name ||
        assignedEvent?.aedState === AedStateEnum.FAILED.name
    ) {
        modalControls.close();
    }
}
